export default __webpack_public_path__ + "static/media/kiss_the_rail.32468e1e.png";